import script from "./Pane6.vue?vue&type=script&setup=true&lang=js"
export * from "./Pane6.vue?vue&type=script&setup=true&lang=js"

import "./Pane6.vue?vue&type=style&index=0&id=2ccb2293&scoped=true&lang=css"

import exportComponent from "/home/interact/webapp/4.frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ccb2293"]])

export default __exports__